<mapfre-card [singleCard]="false" [additionalClasses]="'policy-details'">
  <div class="policy-card">
    <div class="row text-center">
      <div class="col">
        <h1 class="add-policy-title">
          <div class="add-policy-first-name">Hi {{ firstName | titlecase }}, there aren’t any policies currently linked to
          your account.</div>          
          <div>Let’s add a policy.</div>
        </h1>
      </div>
    </div>
    <div class="row text-center margin-top mt16 mb-4">
      <div class="col">
        <mapfre-modal
          [modalOptions]="whereToFindModalOptions"
          [hideModal]="hideModal"
          (hideModalOutput)="resetHideModal()"
        >
          <div class="modal-body no-padding-top">
            <hr class="margin-bottom mb24" />
            <ng-container *ngIf="isAcmic; else MAstate">
              <div class="margin-bottom mb8 fs-14">
                {{ "SEARCH_IN_YOUR_POLICY_DOC_OR_INVOICES" | translate }}
              </div>
              <div class="margin-bottom mb24">
                <img src="./assets/img/images/Document_ref.svg" alt="document ref" />
              </div>
            </ng-container>
            <ng-template #MAstate>
              <div class="margin-bottom mb8 fs-14">
                {{ "SEARCH_YOUR_POLICY_DOCUMENTS_INVOICES" | translate }}
              </div>
              <div class="margin-bottom mb24">
                <img src="./assets/img/images/Document_ref.png" alt="document ref" />
              </div>
            </ng-template>
            <mapfre-button
              additionalClasses="basic primary large-btn no-margin"
              (click)="hideModalAction()"
            >
              CLOSE
            </mapfre-button>
          </div>
        </mapfre-modal>
      </div>
    </div>

    <div class="single-card-column policy-card">
      <app-add-policy-form
        [inputs]="linkPolicy"
        [buttonLabel]="continueButton"
      ></app-add-policy-form>
    </div>
  </div>
</mapfre-card>
